import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, withProps, withHandlers, compose, branch, renderNothing } from 'recompose'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import * as InboxActions from 'app/modules/inbox/actions'
import * as UserSelectors from 'app/modules/user/selectors'
import * as InboxSelectors from 'app/modules/inbox/selectors'

import Avatar from 'shared-web/src/components/Avatar'
import UserSelect from './component'

const mapStateToProps = state => ({
  orgUsers: UserSelectors.nonBotOrgUsersAlphabetical(state),
  orgUsersWithRandom: UserSelectors.randomAndOrgUsersAlphabetical(state),
  inboxes: InboxSelectors.inboxes(state),
  isInboxListLoading: InboxSelectors.isInboxListLoading(state),
  isInboxListLoaded: InboxSelectors.isInboxListLoaded(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchInboxList: InboxActions.fetchInboxList,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (this.props.includeInboxEmails && !this.props.isInboxListLoaded && !this.props.isInboxListLoading) {
        this.props.actions.fetchInboxList()
      }
    },
  }),
  branch(
    ({ orgUsers, includeInboxEmails, isInboxListLoaded }) =>
      !orgUsers.size || (includeInboxEmails && !isInboxListLoaded),
    renderNothing
  ),
  withProps(props => {
    
    const nonCalUsersNormal = props.orgUsers.filter(user => !user.scopes.includes('calendar_user'))

    const nonCalUsersRandom = props.orgUsersWithRandom.filter(user => !user.scopes.includes('calendar_user'))

    const replyArray = () => {
      if (props.includeRandom && !props.restrictCalendarUsers) {
        return props.orgUsersWithRandom
      } else if (props.includeRandom && props.restrictCalendarUsers) {
        return nonCalUsersRandom
      } else if (!props.includeRandom && !props.restrictCalendarUsers) {
        return props.orgUsers
      } else {
        return nonCalUsersNormal
      }
    }

    const correctUserArray = replyArray()

    const replyToOptions = correctUserArray.map(user => {
        return {
          value: user.id,
          user: user,
          label: (
            <div className="flex routing-option">
              <Avatar size="small" user={user} />
              {props.renderOption ? props.renderOption(user) : user.name || user.email}
            </div>
          ),
        }
      })
      .toJS()
    let inboxOptions = []
    if (props.inboxes.size > 0 && props.includeInboxEmails) {
      inboxOptions = props.inboxes
        .toList()
        .map(inbox => ({
          value: inbox.address,
          isInbox: true,
          label: `${inbox.address} (${inbox.name} Inbox)`,
        }))
        .toJS()
    }
    const options = inboxOptions.concat(replyToOptions)
    const isIdEmail = `${props.selectedUserId}`.includes('@')
    const userForEmail = isIdEmail && props.orgUsers.find(user => user.email === props.selectedUserId)
    const inboxForEmail = isIdEmail && inboxOptions.find(inbox => inbox.value === props.selectedUserId)
    const selectedValue = userForEmail
      ? { label: userForEmail.name, value: userForEmail.id }
      : inboxForEmail || props.selectedUserId
    return {
      selectedValue,
      options,
    }
  }),
  withHandlers({
    filter: () => (option, filterText) => {
      if (option.isInbox) {
        return option.label.includes(filterText)
      }
      return getDisplayName(option.user)
        .toLowerCase()
        .includes(filterText)
    },
  })
)(UserSelect)



// WEBPACK FOOTER //
// ./src/scripts/components/UserSelect/index.js